'use strict';


import { Report } from './QAReport';
import { settingsData } from '../../settings';

export class QAApartmentsPlan extends Report{
	constructor () {
		super('2D Plans');
	}
	
	validate() {
		if (this.jsonReport.length) {
			this.showReport();
			return;
		}
		
		if (!Array.isArray(settingsData.allCrmData) || settingsData.allCrmData.length === 0) {
			this.jsonReport.push('CRM data is absent');
			this.showReport();
			return;
		}
		
		settingsData.allCrmData.forEach(prop => {
			if (prop.assets.plan2D.trim().length === 0) {
				this.addError(prop,'Plan 2D is absent.')
			}
		});
		
		this.normalize();
		this.showReport();
	}
	
	normalize () {
		if (!this.log.length) {
			this.jsonReport.push('OK');
		} else {
			this.log.forEach(report => {
				const apartmentString = super.normalize(report.apt);
				let dataString = apartmentString + ' - ' + report.message;
				this.jsonReport.push(dataString);
			});
		}
	}
}
